import type { FC } from 'react';

import logger from '@eneco/common/log';
import { useChat } from '@eneco/components/chat/useChat';
import { Button } from '@eneco/sparky';
import { useMediaQuery } from '@eneco/sparky/hooks';
import { ContactMethod } from '@sitecore/types/ContactMethods';

export const ChatButton: FC<{
  contactMethod: ContactMethod | undefined;
  displayName: string;
}> = ({ contactMethod, displayName }) => {
  const isMediumBreakpoint = useMediaQuery('md');

  try {
    const [mount] = useChat();

    if (!contactMethod) {
      logger.error('NtdDKV', 'ChatButton could not render as contactMethod is undefined');
      return null;
    }

    return (
      <Button
        action="primary"
        size={isMediumBreakpoint ? 'regular' : 'compact'}
        tone="onLight"
        type="button"
        onClick={() =>
          mount({ visibility: 'open', topic: contactMethod?.chatLink?.fields?.chatBotTopic?.chatTopic?.value })
        }>
        {contactMethod?.buttonText?.value}
      </Button>
    );
    //Saveguard against accidental usage outside ChatProvider
  } catch (e) {
    logger.error('NtdDKV', e instanceof Error ? e.message : 'ChatButton could not render');
    return null;
  }
};
